// src/pages/Services/Services.js

import React from "react";
import "./Services.css";

import {
  FaLeaf,
  FaHeartbeat,
  FaFemale,
  FaBaby,
  FaAppleAlt,
  FaBrain,
  FaLungs,
  FaStethoscope
} from "react-icons/fa";

function Services() {

  const services = [
    {
      icon: <FaLeaf />,
      title: "Skin Complaints",
      desc: "Treatment support for acne, eczema, psoriasis, pigmentation, itching and recurring skin issues."
    },
    {
      icon: <FaLungs />,
      title: "Respiratory Issues",
      desc: "Care for cough, cold, sinusitis, asthma, allergies and breathing discomfort."
    },
    {
      icon: <FaHeartbeat />,
      title: "Endocrine Disorders",
      desc: "Support for PCOD, thyroid imbalance, diabetes and obesity management."
    },
    {
      icon: <FaFemale />,
      title: "Women's Health",
      desc: "Care for UTI, irregular periods, dysmenorrhoea and hormonal balance."
    },
    {
      icon: <FaBaby />,
      title: "Paediatric Care",
      desc: "Flu, worms, tonsillitis, adenoids, low immunity and childhood recurring complaints."
    },
    {
      icon: <FaStethoscope />,
      title: "Gut Disorders",
      desc: "IBS, gastritis, ulcers, constipation, diarrhoea, indigestion and acidity support."
    },
    {
      icon: <FaAppleAlt />,
      title: "Diet Plans",
      desc: "Customized nutrition guidance based on body type and health goals."
    },
    {
      icon: <FaBrain />,
      title: "Mental Wellness",
      desc: "Stress management, counseling, emotional wellbeing and parenting support."
    }
  ];

  const goToAppointment = () => {
    window.location.href = "/appointment";
  };

  return (
    <section className="services-page">

      {/* HERO */}
      <div className="services-hero">

        <p className="services-tag">
          ROOTLY SERVICES
        </p>

        <h1>
          Holistic Care For <br />
          Every Stage Of Life
        </h1>

        <p className="services-subtitle">
          Personalized homeopathic treatment with modern wellness support.
        </p>

      </div>

      {/* SERVICES GRID */}
      <div className="services-container">

        <div className="services-grid">

          {services.map((item, index) => (
            <div
              className="service-card"
              key={index}
            >

              <div className="service-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

              <button
                className="service-btn"
                onClick={goToAppointment}
              >
                Book Appointment
              </button>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}

export default Services;